import Thumbnail from "./Thumbnail";

## Basic Usage

<Thumbnail label="Sample thumbnail" />

---

## Sizes

<div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
  <div style={{ textAlign: "center" }}>
    <Thumbnail size="tiny" label="Tiny" />
    <p style={{ fontSize: "12px", marginTop: "0.25rem" }}>Tiny</p>
  </div>
  <div style={{ textAlign: "center" }}>
    <Thumbnail size="small" label="Small" />
    <p style={{ fontSize: "12px", marginTop: "0.25rem" }}>Small</p>
  </div>
  <div style={{ textAlign: "center" }}>
    <Thumbnail size="medium" label="Medium" />
    <p style={{ fontSize: "12px", marginTop: "0.25rem" }}>Medium</p>
  </div>
  <div style={{ textAlign: "center" }}>
    <Thumbnail size="large" label="Large" />
    <p style={{ fontSize: "12px", marginTop: "0.25rem" }}>Large</p>
  </div>
</div>

---

## Color Thumbnails

<div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
  <Thumbnail color="#ef4444" label="Red" />
  <Thumbnail color="#f97316" label="Orange" />
  <Thumbnail color="#eab308" label="Yellow" />
  <Thumbnail color="#22c55e" label="Green" />
  <Thumbnail color="#3b82f6" label="Blue" />
  <Thumbnail color="#8b5cf6" label="Purple" />
  <Thumbnail color="#ec4899" label="Pink" />
</div>

---

## With Images

<div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
  <Thumbnail
    size="medium"
    image="https://via.placeholder.com/100"
    label="Placeholder image"
  />
  <Thumbnail
    size="large"
    image="https://via.placeholder.com/150"
    label="Larger placeholder"
  />
</div>

---

## Color Palette Example

<div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
  <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
    <Thumbnail size="small" color="#1e3a8a" label="Navy" />
    <span>Navy - #1e3a8a</span>
  </div>
  <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
    <Thumbnail size="small" color="#166534" label="Forest" />
    <span>Forest - #166534</span>
  </div>
  <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
    <Thumbnail size="small" color="#9f1239" label="Wine" />
    <span>Wine - #9f1239</span>
  </div>
  <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
    <Thumbnail size="small" color="#78716c" label="Stone" />
    <span>Stone - #78716c</span>
  </div>
</div>

---

## In a List Item

<div style={{ display: "flex", alignItems: "center", gap: "0.75rem", padding: "0.5rem", border: "1px solid #e5e5e5", borderRadius: "6px", maxWidth: "300px" }}>
  <Thumbnail size="medium" color="#3b82f6" label="Project" />
  <div>
    <div style={{ fontWeight: 500 }}>Project Alpha</div>
    <div style={{ fontSize: "12px", color: "#666" }}>Last updated 2 days ago</div>
  </div>
</div>


